var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoslides07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 637.65 555.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #231f20;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 160.57,
    width: 68.33,
    height: 68.33
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 487.28,
    width: 68.33,
    height: 68.33
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80.87,
    width: 68.33,
    height: 68.33
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80.87,
    y: 160.57,
    width: 68.33,
    height: 68.33
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80.87,
    y: 242.24,
    width: 68.33,
    height: 68.33
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80.87,
    y: 323.92,
    width: 68.33,
    height: 68.33
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80.87,
    y: 405.6,
    width: 68.33,
    height: 68.33
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80.87,
    y: 487.28,
    width: 68.33,
    height: 68.33
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 161.74,
    y: 487.28,
    width: 68.33,
    height: 68.33
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 242.88,
    y: 242.24,
    width: 68.33,
    height: 68.33
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 242.88,
    y: 323.92,
    width: 68.33,
    height: 68.33
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 242.88,
    y: 405.6,
    width: 68.33,
    height: 68.33
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 324.29,
    y: 160.57,
    width: 68.33,
    height: 68.33
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 324.29,
    y: 323.92,
    width: 68.33,
    height: 68.33
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 324.29,
    y: 487.28,
    width: 68.33,
    height: 68.33
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 405.97,
    y: 160.57,
    width: 68.33,
    height: 68.33
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 405.97,
    y: 323.92,
    width: 68.33,
    height: 68.33
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 405.97,
    y: 487.28,
    width: 68.33,
    height: 68.33
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 487.65,
    y: 160.57,
    width: 68.33,
    height: 68.33
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 487.65,
    y: 323.92,
    width: 68.33,
    height: 68.33
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 487.65,
    y: 487.28,
    width: 68.33,
    height: 68.33
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 569.32,
    y: 242.24,
    width: 68.33,
    height: 68.33
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 569.32,
    y: 487.28,
    width: 68.33,
    height: 68.33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoslides07);
export default __webpack_public_path__ + "static/media/logo slides 07.0ae35132dbeea2982b5e6b4fcb232da7.svg";
export { ForwardRef as ReactComponent };